import { render, staticRenderFns } from "./HandwrittenEraseDetail.vue?vue&type=template&id=01b1747a&scoped=true"
import script from "./HandwrittenEraseDetail.vue?vue&type=script&lang=js"
export * from "./HandwrittenEraseDetail.vue?vue&type=script&lang=js"
import style0 from "./HandwrittenEraseDetail.vue?vue&type=style&index=0&id=01b1747a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b1747a",
  null
  
)

export default component.exports